// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"d0eb9ac2","216":"602b06a8","239":"e1bdea79","311":"c3830ebf","455":"5a542a34","488":"29c45b55","564":"4e73d92c"}[chunkId] + ".chunk.js";
};